export const APP_PAGE_SIGN_UP_PROVIDER_SERVICES_MODAL = "APP_PAGE/SIGN_UP_PROVIDER_SERVICES_MODAL";
export const signUpProviderServicesModal = ({isOpen = false})=>{
    return {
        type: APP_PAGE_SIGN_UP_PROVIDER_SERVICES_MODAL,
        payload: {isOpen: isOpen}
    }
}